import { useEffect } from 'react';
import triggerWootricSurvey from 'ContentEditorUI/utils/triggerWootricSurvey';
export const WootricSurveyNames = {
  PAGES_EDITOR: 'LPSP_EDITOR',
  BLOG_EDITOR: 'BLOG_EDITOR',
  GLOBAL_CONTENT_EDITOR: 'GLOBAL_EDITOR',
  EMBEDS_EDITOR: 'EMBEDS_EDITOR'
};
const TriggerWootricCsatSurvey = ({
  surveyName
}) => {
  useEffect(() => {
    triggerWootricSurvey(surveyName);
  }, [surveyName]);
  return null;
};
export default TriggerWootricCsatSurvey;